import React, { Component } from 'react'
import styles from './index.module.less'
import { Button } from 'antd'

export default class Title extends Component {
  render() {
    return (
      <div className={styles.title}>
        <h1>大搜车解决方案</h1>
        <p>让汽车产业数字化，便捷产业链，共享幸福家园</p>
        <Button type="primary" size="large">立即咨询</Button>
      </div>
    )
  }
}